import React, { Fragment } from 'react';
import { ExcelTableCellProps } from '../TableCell';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import InputElement from './input-element';
import TextareaElement from './textarea-element';
import BrowserElement from './browser-element';
import CheckboxElement from './checkbox-element';
import SelectElement from './select-element';
import UploadElement from './upload-element';
import HrefElement from './href-element';
import { getDomIdByFieldKey } from '../../../util/typeUtil';
import PopoverTips from '../PopoverTips';
import { CellProps } from '../../../stores/card/ModeExcel';
import { modeForm } from '../../../util/excelUtil';

@observer
export default class ExcelTableCellField extends React.Component<ExcelTableCellProps, any> {
    renderContent = (bindObj, cell: CellProps) => {
        const {  form, card, index,excel } = this.props;
        const path = cell.getPath();
        const { fieldhtmltype = '0' } = card.getFieldProps(path)
        const { isHide, viewAttr, value } = bindObj.bind();
        const classNames = bindObj.isValid ? 'cube-check-valid' : 'cube-check-error';
        if (fieldhtmltype == '0') {
            return <div />
        }
        if (typeof (card.getEcmeFieldData) == 'function') {
            try {
                let fieldData = card.getEcmeFieldData(path, bindObj.bind());
                if (fieldData) {
                    return (fieldData);
                }
            } catch (e) { }

        }
        if ((isHide || viewAttr == '4')) {
            let domid = getDomIdByFieldKey(bindObj.path);
            return <div className={classnames('fieldValue', classNames)} data-fieldmark={domid} {...cell.cellProps}>
                <input
                    type="hidden"
                    id={domid}
                    name={domid}
                    value={value} />
            </div>
        } else {
            if (fieldhtmltype == '1') { //单行文本
                return (
                    <InputElement cell={cell} form={form} card={card}  excel={excel} className={classNames} index={index} />
                )
            } else if (fieldhtmltype == '2') { //多行文本
                return (
                    <TextareaElement cell={cell} form={form} card={card}  excel={excel} className={classNames} index={index} />
                )
            } else if (fieldhtmltype == '3') { //浏览框、日期、时间
                return (
                    <BrowserElement cell={cell} form={form} card={card}  excel={excel} className={classNames} index={index} />
                )
            } else if (fieldhtmltype == '4') { //check框
                return (
                    <CheckboxElement cell={cell} form={form} card={card}  excel={excel} className={classNames} index={index} />
                )
            } else if (fieldhtmltype == '5') {//选择框
                return (
                    <SelectElement cell={cell} form={form} card={card}  excel={excel} className={classNames} index={index}/>
                )
            } else if (fieldhtmltype == '6') { //附件上传
                return (
                    <UploadElement cell={cell} form={form} card={card}  excel={excel} className={classNames} index={index} />
                )
            } else if (fieldhtmltype == '7') { //特殊字段
                return (
                    <HrefElement cell={cell} form={form} card={card}  excel={excel} className={classNames} index={index} />
                )
            }

        }

        return (
            <div />
        )
    }

    proxyCompFn = (bindObj, cell: CellProps) => {
        // const forceRender = ;     //仅为强制render
        // const { card } = this.props;
        let fieldName = getDomIdByFieldKey(bindObj.path);

        const { _viewAttr, isEdit, isMandatory } = bindObj.bind();
        let viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        // const { forceRender} = bindObj.bind();
        // console.log(forceRender)
        const result: any = [];
       // const _fieldName = fieldName.indexOf('_') >0 ? fieldName.split('_')[0] :fieldName; //#813884加的，但是影响了明细表的渲染
        const proxyCompFn = modeForm.getCustomProxyCompFn(`FieldContent_${fieldName}`);

        if (proxyCompFn === null) {
            const proxyComp = modeForm.renderCustomComp(fieldName, viewAttr, 1, this.props);
            const afterComp = modeForm.renderCustomComp(fieldName, viewAttr, 2);
            result.push(proxyComp == null ? this.renderContent(bindObj, cell) : proxyComp);
            if (afterComp !== null)
                result.push(afterComp);
        } else {
            const fieldinfo = modeForm.getFieldInfo(fieldName);
            const needFieldInfo = {
                fieldMark: fieldName,
                fieldValue: modeForm.getFieldValue(fieldName),
                fieldid: fieldinfo.fieldid,
                rowIndex: fieldinfo.isdetail ? fieldName.split('_')[1] : '-1',
                viewAttr: fieldinfo.viewattr,
            };
            result.push(proxyCompFn(needFieldInfo, this.renderContent.bind(this, bindObj, cell)));
        }
        return result;
    }

    render() {
        const { cell, form } = this.props;
        const path = cell.getPath()
        const bindObj = form.has(path) ? form.$(path) : {};
        return (
            <PopoverTips
                error={bindObj.tips ? bindObj.tips : { visible: false, msg: '' }}
                type="error"
                label={bindObj.label}>
                {bindObj.bind ? <Fragment >{this.proxyCompFn(bindObj, cell)}</Fragment> : <div />}
            </PopoverTips>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/index.tsx